<!-- Expanded Mode -->
<div *ngIf="isExpanded()" class="workspaces-container">
  <div class="start-new-wrapper" (click)="newWorkspaceOrDataset()">
    <div class="start-new-icon"></div>
    <div>Start new</div>
  </div>

  <!-- Remove Search until we can build a data search feature -->
  <!-- <div class="search-wrapper" (click)="searchWorkspace()">
    <div class="search-icon"></div>
    <div *ngIf="!showSearchInput">
      {{ isStringSearchable() ? searchValue() : "Search workspace" }}
    </div>
    <input
      *ngIf="showSearchInput"
      type="search"
      placeholder="Search workspace"
      (blur)="closeSearch()"
      [value]="searchValue()"
      (input)="onSearchChange($event)"
      autofocus
    />
  </div> -->

  <div class="workspace-wrapper">
    <div class="workspace-icon"></div>
    <div>Dataspaces</div>
    <div class="ms-2 dataspace-count">({{ getDataspaceCount() }})</div>
  </div>
  <div *ngIf="tables.length === 0 && isStringSearchable()" class="no-results-container">
    <div class="no-results-message">
      <div>0 results for your search</div>
      <div class="no-results-search-value">"{{ searchValue() }}"</div>
    </div>
  </div>

  <div class="index-wrapper dataspace-mini-index" cdkDropList (cdkDropListDropped)="onDataspacesDrop($event)"
    [cdkDropListDisabled]="isStringSearchable() || isAnyDataspaceBeingRenamed()">
    <div class="workspace-items-container ps-2">
      <div class="workspace-item" *ngFor="let _table of getDataspaces(); let index = index; trackBy: trackDataspaceById" 
           cdkDrag [cdkDragDisabled]="isStringSearchable() || isAnyDataspaceBeingRenamed() || _table.isNameEdit">
        <a [ngClass]="{active: _table.tableId == activeTable, 'dropdown-open': dropdown.isOpen()}" *ngIf="!_table.containerId">
          <div *ngIf="_table.loading" class="data-source-type-icon spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></div>
          <div *ngIf="!_table.loading" class="data-source-type-icon" [ngClass]="_table.file?.extension"></div>
          <div class="table-item" (click)="getSpreadSheet(_table)">
            <div [title]="_table.tableName" *ngIf="!_table.isNameEdit">
              {{ _table.tableName }}
            </div>
            <input *ngIf="_table.isNameEdit" [(ngModel)]="_table.editedName" (keydown)="onRenameKeydown($event, _table)"
              (blur)="tableRename(_table)" (keydown.space)="$event.stopPropagation()" (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()"
              (touchstart)="$event.stopPropagation()" />
          </div>

          <span ngbDropdown #dropdown="ngbDropdown">
            <button class="btn" id="dropdownBasic1" ngbDropdownToggle>
              <div class="docs-count">{{ _table.fileCount }}</div>
              <i class="bi bi-three-dots"></i>
            </button>

            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="meatball-menu">
              <div class="meatball-menu-item" (click)="startRename(_table, dropdown)">
                <img src="../../../../assets/img/icons/rename.svg" alt="Rename" />
                <div>Rename</div>
              </div>
              <div (click)="confirm(deleteTableModel, _table.tableId)" class="meatball-menu-item">
                <img src="../../../../assets/img/icons/delete.svg" alt="Delete" />
                <div>Delete</div>
              </div>
            </div>
          </span>
        </a>
      </div>
    </div>

  </div>
</div>

<div *ngIf="!isExpanded()" class="workspaces-container collapsed">
  <div>
    <div class="start-new-icon" (click)="newWorkspaceOrDataset()"></div>
  </div>

  <div>
    <div class="search-icon" (click)="toggleSidebar(); searchWorkspace()"></div>
  </div>

  <div>
    <div class="workspace-icon" (click)="toggleSidebar()"></div>
  </div>
</div>

<!-- Modal (shared between both modes) -->
<ng-template #deleteTableModel let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="icon-stack">
        <div class="icon-main">
          <img src="../../../../assets/img/icons/delete_workspace_icon.svg" alt="Delete icons" />
          <span class="icon-status" aria-hidden="true">
            <svg class="trash-svg" width="12" height="13.5" viewBox="0 0 12 13.5" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.5 3.5h9M4.5 3.5v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1M10 3.5l-.6 7.2a1 1 0 0 1-1 .8H3.6a1 1 0 0 1-1-.8L2 3.5M5 6v4M7 6v4"
                stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        <div>
          <h4 class="confirm-title">
            Are you sure you want to delete this workspace?
          </h4>
          <p class="confirm-subtext">
            By deleting this workspace, you’ll lose all uploaded documents in
            it.
          </p>
        </div>
      </div>
      <div class="button-group">
        <button class="btn cancel-btn text-decoration-none" data-bs-dismiss="modal"
          (click)="modal.close('Close click')">
          Cancel
        </button>
        <button type="button" class="btn delete-btn" id="delete-product"
          (click)="deleteTable(deleteId); modal.close('Close click')">
          Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>